/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaEstadosDetallesVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaEstadosDetalles: React.FunctionComponent<ITablaEstadosDetallesVistaProps & InjectedIntlProps> = ({
    estadosDetalless,
    cargarEstadosDetalles,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={estadosDetalless}
            actions={acciones(manejarFormulario, cargarEstadosDetalles, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaEstadosDetalles);
